import React from 'react';
 
import EquipmentSelector from '../equipment/EquipmentSelector';
import ParameterControl from '../parameters/ParameterControl';
import SystemStats from '../parameters/SystemStats';
import UserSelector from '../users/UserSelector'; // Yeni bileşen (henüz oluşturulmadı)

const Sidebar = ({ 
  darkMode, 
  activeAccordion,
  setActiveAccordion,
  globalParams,
  handleGlobalParamChange,
  handleEquipmentClick,
  systems,
  totalResults
}) => {
  return (
    <div className={`fixed left-4 top-20 ${darkMode ? 'bg-gray-800' : 'bg-white'} p-4 rounded-lg shadow-lg w-80 z-40 mt-8`}>
      {/* w-64 değerini w-80 olarak değiştirerek genişliği artırdık */}
     
      {/* Accordion Menus */}
      <div className="space-y-4 mt-4">
        {/* Equipment Selector - başlık "Kaynaklar" olarak değiştirildi */}
        <EquipmentSelector 
          darkMode={darkMode}
          activeAccordion={activeAccordion}
          setActiveAccordion={setActiveAccordion}
          handleEquipmentClick={handleEquipmentClick}
          title="Kaynaklar" // Başlık değişikliği
        />

        {/* Kullanıcılar - yeni eklenen accordion */}
        <UserSelector
          darkMode={darkMode}
          activeAccordion={activeAccordion}
          setActiveAccordion={setActiveAccordion}
          handleUserClick={handleEquipmentClick} // Şimdilik aynı işleyişi kullanıyoruz
          systems={systems} // Sistemleri geçiyoruz
        />

        {/* Parameter Controls */}
        <ParameterControl 
          darkMode={darkMode}
          activeAccordion={activeAccordion}
          setActiveAccordion={setActiveAccordion}
          globalParams={globalParams}
          handleGlobalParamChange={handleGlobalParamChange}
        />
      </div>

      {/* System Stats */}
      {systems.length > 0 && (
        <div className="mt-6">
          <SystemStats 
            totalResults={totalResults} 
            darkMode={darkMode} 
          />
        </div>
      )}
    </div>
  );
};

export default Sidebar;